module.exports = __webpack_public_path__ + "static/media/logo_strong_vertical.0d23fedc.svg";